import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'

export const startCanvasConnect = (
  instrFirstName,
  instrEmail,
  instrId,
  instrCourses,
  connectedCourses,
  hasScopedKey
) => {
  ReactDOM.render(
    <App
      instrFirstName={instrFirstName}
      instrEmail={instrEmail}
      instrId={instrId}
      instrCourses={instrCourses}
      connectedCourses={connectedCourses}
      hasScopedKey={hasScopedKey === 'true'}
    />,
    document.getElementById('canvasConnectApp')
  )
}
